/**
 * Tiny live-data indicator. When `pulse` is true, indicates a refresh in
 * flight; otherwise shows a steady dot meaning data is current.
 */
export function LiveDot({ pulse, color = "var(--lm-accent)" }: { pulse: boolean; color?: string }) {
  return (
    <span className="relative inline-flex h-1.5 w-1.5" aria-label={pulse ? "refreshing" : "live"}>
      <span
        className={
          "inline-flex h-1.5 w-1.5 rounded-full " + (pulse ? "animate-ping absolute inset-0 opacity-75" : "")
        }
        style={{ background: color }}
      />
      <span className="relative inline-flex h-1.5 w-1.5 rounded-full" style={{ background: color }} />
    </span>
  );
}
